export const PAGE_URL_SEARCH_PARAM = 'page' as const;
export const SORT_URL_SEARCH_PARAM = 'sort' as const;
export const SLUG_FALLBACK_URL_SEARCH_PARAM = 'slug-fallback' as const;

export type SupportedURLSearchParam = typeof PAGE_URL_SEARCH_PARAM | typeof SORT_URL_SEARCH_PARAM | typeof SLUG_FALLBACK_URL_SEARCH_PARAM;